var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    focusable: "false",
    color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
    style: {
      userSelect: "none",
      width: "100%",
      height: "100%",
      display: "inline-block",
      fill: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
      color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
      flexShrink: 0
    },
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
    weight: "regular",
    fill: "#FFFCF5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216,64H176a48,48,0,0,0-96,0H40A16,16,0,0,0,24,80V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM128,32a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm88,168H40V80H80V96a8,8,0,0,0,16,0V80h64V96a8,8,0,0,0,16,0V80h40Z",
    fill: "#FFFCF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.511e32eea6f8edd366b77f07f40d620e.svg";
export { ForwardRef as ReactComponent };